import { ChecklistCheckpointsComponent } from '../checklist-checkpoints/checklist-checkpoints.component';
import { NgModule, ModuleWithProviders } from '@angular/core';

import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { KubaCompleteChecklistComponent } from './kuba-complete-checklist.component';
import { VehiclesCompleteChecklistComponent } from './kuba-vehicles-complete-checklist.component';
import { FoodSafetyCompleteChecklistComponent } from './kuba-foodsafety-complete-checklist.component';
import { KubaCompleteSafteyJobChecklistComponent } from './kuba-safety-job-analysis-complete-checklist.component';
import { EcplDocumentTreeModule } from 'src/app/shared/ecpl-document-tree/ecpl-document-tree.module';
import { EcplDocumentExplorerModule } from 'src/app/shared/ecpl-document-explorer';
import { CompleteCheckListServices } from '../services/complete-checklist.service';
import { TableModule } from 'primeng/table';
import { AppSharedModule } from '../appShared.module';
import { EditorModule } from 'primeng/editor';
import { DatePickerModule } from 'primeng/datepicker';
import { TextareaModule } from 'primeng/textarea';
import { ContextMenuModule } from 'primeng/contextmenu';
import { SharedModule } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { StepperModule } from 'primeng/stepper';
import { MenuModule } from 'primeng/menu';
@NgModule({
  imports: [
    CommonModule,
    ChecklistCheckpointsComponent,
    RouterModule,
    FormsModule,
    AppSharedModule,
    EditorModule, DatePickerModule, ContextMenuModule,
    MenuModule, SelectModule, TextareaModule,
    InputTextModule, ButtonModule, TableModule, SharedModule, DialogModule, CheckboxModule
    , StepperModule, EcplDocumentTreeModule, EcplDocumentExplorerModule,InputNumberModule,
    TabsModule
  ],
  declarations: [KubaCompleteChecklistComponent, FoodSafetyCompleteChecklistComponent,VehiclesCompleteChecklistComponent, KubaCompleteSafteyJobChecklistComponent],
  providers: [CompleteCheckListServices]
})
export class KubaCompleteChecklistModule {
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: KubaCompleteChecklistModule
    };
  }
}
